import { Component } from '@angular/core';
import { EnquirySidebarService } from '../../enquiry-sidebar/service/enquiry-sidebar.service';

@Component({
  selector: 'app-new-pricing',
  standalone: true,
  imports: [],
  templateUrl: './new-pricing.component.html',
  styleUrl: './new-pricing.component.scss'
})
export class NewPricingComponent {
  isOpen = false;
  isScrolled = false;

  constructor(private enquiryService: EnquirySidebarService){

  }

  openEnquiry() {
  this.enquiryService.open();
}

   billing: 'monthly' | 'annual' = 'monthly';

  setBilling(type: 'monthly' | 'annual') {
    this.billing = type;
  }

  getValue(monthly: string, annual: string) {
    return this.billing === 'annual' ? annual : monthly;
  }
}
